<template>
  <div class="ceo">
    <transition mode="out-in">
      <div class="ceo_img animated bounce">
        <img src="../assets/images/ceo.png" alt="头像">
        <div class="name">
          <h2>{{$t('lang.ceo_info_name')}}</h2>
          <p>{{$t('lang.ceo_info_nick')}}</p>
        </div>
      </div>
    </transition>

    <div class="ceo_memo animated bounceInRight">
      <h2>{{$t('lang.ceo_info_title')}}</h2>
      <p><span v-if="this.$i18n.locale === 'zh-CN' ">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>{{$t('lang.ceo_info_text1')}}</p>
      <p><span v-if="this.$i18n.locale === 'zh-CN' ">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>{{$t('lang.ceo_info_text2')}}</p>
      <p><span v-if="this.$i18n.locale === 'zh-CN' ">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>{{$t('lang.ceo_info_text3')}}</p>
      <p><span v-if="this.$i18n.locale === 'zh-CN' ">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>{{$t('lang.ceo_info_text4')}}</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
@import "../assets/less/global.less";
.ceo {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 133px;
  display: flex;
  display: -webkit-flex;
  max-height: 90%;
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 1px;
    background: @bordercolor;
  }
  @media screen and (max-width: 768px) {
    padding-top: 20px;
    flex-wrap: wrap;
  }
  .ceo_img {
    width: 213px;
    text-align: center;
    h2 {
      font-size: 20px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    p {
      font-size: 16px;
    }
    @media screen and (max-width: 768px) {
      display: flex;
      display: -webkit-flex;
      width: 100%;
      margin-bottom: 24px;
      img {
        width: 106px;
        height: 106px;
      }
      .name {
        margin-left: 20px;
        text-align: left;
      }
    }
  }
  .ceo_memo {
    margin-left: 90px;
    @media screen and (max-width: 768px) {
      margin-left: 0;
    }
    h2 {
      font-size: 32px;
      font-weight: 400;
      margin-bottom: 30px;
      @media screen and (max-width: 768px) {
        font-size: 18px;
        margin-bottom: 10px;
      }
    }
    p {
      font-size: 16px;
      line-height: 32px;
    }
  }
}
</style>
